import React, {useEffect, useState} from "react";
import {Header} from "../../../components/Header";
import {Container} from "../../../components/Container";
import {Block} from "../../../components/Block";
import {API} from "../../../api";
import {isMobileDevice} from "../../../hooks/mobile/isMobile";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router";
import {BackButton} from "../../../components/BackButton";
import {BlockSide} from "../../../components/Block/BlockSide";
import {RowUser} from "./rowUser";
import {RoomUserSettingsModal} from "../../../modals/RoomUserSettingsModal";

const api = new API();

export function UsersPage({isMobile=isMobileDevice()}) {
    const navigate = useNavigate();
    const {room_hash} = useParams();

    const [users, setUsers] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const goBack = () => {
        navigate(`/room/${room_hash}/controls`)
    };

    useEffect(() => {
        api.getRoomUsers(room_hash).then(resp => {
            setUsers(resp);
        })
    }, []);

    return <div>
        <Header  />
        <Container paddingTop="0px">

            <BackButton backPath={`/room/${room_hash}/controls`} />
            <h1 style={{whiteSpace: 'nowrap', textOverflow: "ellipsis", overflowX: "hidden"}}>Участники комнаты</h1>

            <Block style={{marginBottom: '10px'}} height={isMobile ? "100dvh - 200px" : "100dvh - 350px"} smallPadding={isMobile}>
                <BlockSide col={true}>
                    {users && users.map((user) => {
                        return <RowUser user={user} onClick={(uid) => {
                            for (const u of users) {
                                if (u.id === uid) {
                                    setSelectedUser(u);
                                    setIsOpen(true);
                                    return;
                                }
                            }
                        }} />
                    })}
                </BlockSide>
            </Block>
        </Container>

        <RoomUserSettingsModal isOpen={isOpen} setOpen={setIsOpen} selectedUser={selectedUser} />
    </div>
}
